module.exports = __webpack_public_path__ + "img/caret-down.4c87f29a.png";